import React, { useEffect } from "react";
import {
  ModalPageBody,
  ModalPageFooter,
  ModalPageWrapper,
  ModalPageCopy,
  ModalPageHeroImage,
  ModalPageHeading,
  ModalPageHeader,
} from "../../organisms/ModalPage";
import { Helmet } from "react-helmet";
import HeroImage from "../../../assets/img/meetGlojiTeam.png";
import { useDispatch } from "react-redux";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import { get_signup_copy } from "../../../store/actions/signupFlowData";
import { CircularLoader } from "../../atoms/Loaders";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useHistory } from "react-router";
import MarkedDownContent from "../../organisms/MarkedDownContent";
import useUser from "../../hooks/useUser";
import { PowerOfTen, ProgressStepEnum, setStepProgress } from "../../../redux/slices/progressBarSlice";
import { IsObjectEmptyOrNull } from "../../../utils/IsEmpty";

interface LandingPageData {
  title: string;
  body: string;
}

interface LandingPageProps {
  programmeTitle: string;
  landingPageData: LandingPageData;
  nextStepUrl: string;
  isLoading?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  progressPercentage?: PowerOfTen;
}

const LandingPage: React.FC<LandingPageProps> = (props: LandingPageProps) => {
  const {
    programmeTitle,
    landingPageData,
    isLoading,
    hasError,
    errorMessage,
    nextStepUrl,
    progressPercentage,
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const [user] = useUser();

  useEffect(() => {
    if (!IsObjectEmptyOrNull(progressPercentage)) {
      dispatch(
        setStepProgress({
          progressStepEnum: ProgressStepEnum.CheckEligiblity,
          progressPercentage: progressPercentage,
        })
      );
    }
  }, [dispatch, progressPercentage]);

  useEffect(() => {
    dispatch(get_signup_copy("eligibility-checker"));
  }, [dispatch]);

  const handleContinue = () => {
    //Trigger google analytics event at the start of eligibility checker journey
    window.gtag("event", "startEligibilityChecker", {
      event_category: "Eligibility Checker",
      event_label: `Start ${programmeTitle} Eligibility Checker`,
    });

    history.push(nextStepUrl);
  };

  return (
    <>
      <Helmet>
        <title>{`Lets team up | ${programmeTitle} | Eligibility checker | Sign up | Gloji`}</title>
      </Helmet>
      <ModalPageWrapper>
        <ModalPageBody hasStickyFooter={false}>
          {isLoading === true ? (
            <CircularLoader />
          ) : hasError === true ? (
            <ModalPageCopy>
              <Alert severity="error" style={{ marginTop: "2rem" }}>
                <AlertTitle>{errorMessage} </AlertTitle>
                Failed to load data
              </Alert>
            </ModalPageCopy>
          ) : landingPageData ? (
            <>
              <ModalPageHeader
                backButtonOnClick={() => {
                  if (user) {
                    window.location.href = "/";
                  } else {
                    window.location.href = "/select-programme";
                  }
                }}
              />
              <ModalPageHeading size="large">{landingPageData.title}</ModalPageHeading>
              <ModalPageHeroImage imageUrl={HeroImage} altText="gloji team"></ModalPageHeroImage>
              <ModalPageCopy>
                <MarkedDownContent content={landingPageData.body} />
              </ModalPageCopy>
            </>
          ) : (
            <CircularLoader />
          )}
        </ModalPageBody>
        <ModalPageFooter hasStickyFooter={false}>
          <Button onClick={handleContinue} variant="contained" color="primary">
            Let's go
          </Button>
        </ModalPageFooter>
      </ModalPageWrapper>
    </>
  );
};

export default LandingPage;
